"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewWrapper = exports.TextWrapper = exports.StyledLink = exports.StyledButton = exports.SectionTitle = exports.SectionSubtitle = exports.SectionDelimiter = exports.Section = exports.ButtonWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
var _colorUtils = require("../../utils/color-utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ViewWrapper = exports.ViewWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ViewWrapper",
  componentId: "sc-p1d3o3-0"
})(["max-width:722px;width:100%;margin:0 auto;"]);
var Section = exports.Section = _styledComponents["default"].div.withConfig({
  displayName: "styles__Section",
  componentId: "sc-p1d3o3-1"
})(["display:flex;justify-content:space-between;align-items:", ";", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 'left' : 'center';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 'flex-direction: column;' : '';
});
var TextWrapper = exports.TextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__TextWrapper",
  componentId: "sc-p1d3o3-2"
})(["flex:4;margin-bottom:", ";"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? '16px;' : '';
});
var SectionTitle = exports.SectionTitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__SectionTitle",
  componentId: "sc-p1d3o3-3"
})(["font-weight:600;font-size:16px;line-height:24px;margin-bottom:10px;"]);
var SectionSubtitle = exports.SectionSubtitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__SectionSubtitle",
  componentId: "sc-p1d3o3-4"
})(["font-weight:400;font-size:16px;line-height:24px;margin-top:8px;"]);
var SectionDelimiter = exports.SectionDelimiter = _styledComponents["default"].div.withConfig({
  displayName: "styles__SectionDelimiter",
  componentId: "sc-p1d3o3-5"
})(["border-bottom:1px solid ", ";margin:30px 0;"], _palette.commonPalette.borderGrey);
var StyledLink = exports.StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "styles__StyledLink",
  componentId: "sc-p1d3o3-6"
})(["color:inherit;font-weigth:600;border-bottom:1px solid ", ";padding-bottom:1px;&:hover{color:", ";}"], _palette.commonPalette.txBlack, _palette.commonPalette.txBlack);
var StyledButton = exports.StyledButton = _styledComponents["default"].a.withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-p1d3o3-7"
})(["color:", ";background:", ";padding:10px;text-decoration:none;border-radius:4px;text-align:center;flex:1;&:hover{color:", ";background:", ";}&:link{text-decoration:none;}", ""], _palette.commonPalette.white, _palette.commonPalette.sgGreen, _palette.commonPalette.white, (0, _colorUtils.darken)(_palette.commonPalette.sgGreen, 0.15), function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? 'margin: 10px auto 0 0;' : '';
});
var ButtonWrapper = exports.ButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "sc-p1d3o3-8"
})(["width:135px;display:flex;", " flex:1;"], function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? '' : 'margin-left: 40px;';
});
//# sourceMappingURL=styles.js.map